import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import statisticService from '../../../services/statistics';

const initialState = {
  loading: false,
  sum: {},
  error: '',
};

export const fetchStatisticsSum = createAsyncThunk(
  'statistics/fetchStatisticsSum',
  (params = {}) => {
    return statisticService.getAll(params).then((res) => res);
  }
);

const statisticsSumSlice = createSlice({
  name: 'statisticsSum',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchStatisticsSum.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchStatisticsSum.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.sum = payload.data[0];
      state.error = '';
    });
    builder.addCase(fetchStatisticsSum.rejected, (state, action) => {
      state.loading = false;
      state.sum = {};
      state.error = action.error.message;
    });
  },
});

export default statisticsSumSlice.reducer;
